import axios from "axios";

import { MARKETPLACE_API_URL } from "../config/apiConfig";

/**
 * Client HTTP unique vers agri-product-platform (via l'API Gateway).
 * Ajoute le JWT de l'utilisateur connecté à chaque requête.
 */
export const createMarketplaceHttpClient = ({ authenticated = true } = {}) => {
    const client = axios.create({
        baseURL: MARKETPLACE_API_URL,
        headers: {
            "Content-Type": "application/json"
        }
    });

    if (authenticated) {
        client.interceptors.request.use(config => {
            const token = localStorage.getItem("token");
            if (token) {
                config.headers.Authorization = `Bearer ${token}`;
            }
            return config;
        });
    }

    return client;
};
